import React from 'react';
import { Link } from 'react-router-dom';

export const AuthMenu = () => {
    return (
        <React.Fragment>
            <Link className="btn btn-outline-primary me-2" to="login">
                Login
            </Link>
            <Link className="btn btn-primary" to="register">
                Register
            </Link>
        </React.Fragment>
    );
};
